<script setup lang="ts">
import type { ComboboxGroupProps } from '@blintz/radix-vue';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { ComboboxGroup, ComboboxLabel } from '@blintz/radix-vue';
import { computed } from 'vue';

const props = defineProps<
	ComboboxGroupProps & {
		class?: HTMLAttributes['class'];
		heading?: string;
	}
>();

const slots = defineSlots();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<ComboboxGroup
		v-bind="delegatedProps"
		:class="
			cn(
				'overflow-hidden p-1 text-foreground **:[[cmdk-group-heading]]:px-2 **:[[cmdk-group-heading]]:py-1.5 **:[[cmdk-group-heading]]:text-xs **:[[cmdk-group-heading]]:font-medium **:[[cmdk-group-heading]]:text-muted-foreground',
				props.class
			)
		"
	>
		<ComboboxLabel v-if="heading || slots.default">
			<slot name="heading">
				{{ heading }}
			</slot>
		</ComboboxLabel>
		<slot />
	</ComboboxGroup>
</template>
